import React from 'react';

import LogoRimac from '../../../assets/logo_rimac.svg';
import IconApp from '../../../assets/ic_app_red.svg';
import IconGoogle from '../../../assets/ic_gplay_red.svg';

const RimacFooter = ({ isAppInfoActive }) => {
  return (
    <footer className="rimacFooter">
      <div className="rimacFooter__wrapper">
        <div className="rimacFooter__left">
          <img className="imgLogo" src={LogoRimac} alt="Logo Rimac" />
          <p className="infoTxt">© 2023 RIMAC Seguros y Reaseguros.</p>
          <p className="infoTxt hide">© 2023 RIMAC Seguros y Reaseguros.</p>
        </div>
        {isAppInfoActive && (
          <>
            <hr className="horizontalDivider" />
            <div className="rimacFooter__right">
              <p className="titleMobile">Descarga nuestra App</p>
              <div className="appLink">
                <img className="imgLogo" src={IconApp} alt="Logo Rimac" />
                <p>App Store</p>
              </div>
              <div className="verticalDivider"></div>
              <div className="appLink">
                <img src={IconGoogle} alt="Logo Rimac" />
                <p>Google Play</p>
              </div>
            </div>
          </>
        )}
      </div>
    </footer>
  );
};

export default RimacFooter;
